/**
 * Section: For You
 * Handles playlist modal functionality
 * Uses same classes as w-ATC-PRODUCT-PL for compatibility
 */

(function() {
  // Avoid double declaration
  if (window.ForYouPlaylistModalInitialized) return;
  window.ForYouPlaylistModalInitialized = true;

  class ForYouPlaylistModal {
    constructor() {
      this.initPlaylistModal();
      this.setupDeviceDetection();
    }


    setupDeviceDetection() {
      const ctaButton = document.querySelector(
        ".for-you__button--custom"
      );
      if (!ctaButton) return;

      const iosLink = ctaButton.getAttribute("data-ios-link");
      const androidLink = ctaButton.getAttribute("data-android-link");
      const defaultLink = ctaButton.getAttribute("data-default-link");

      // If no device-specific links are set, keep default behavior
      if (!iosLink && !androidLink) return;

      // Detect device
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      let detectedLink = defaultLink;

      // iOS detection (iPhone, iPad, iPod)
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        detectedLink = iosLink || defaultLink;
      }
      // Mac detection (use iOS link for Mac)
      else if (/Macintosh|MacIntel|MacPPC|Mac68K/i.test(userAgent)) {
        detectedLink = iosLink || defaultLink;
      }
      // Android detection
      else if (/android/i.test(userAgent)) {
        detectedLink = androidLink || defaultLink;
      }
      // Windows and other devices use defaultLink (already set)

      // Update the href if a device-specific link was detected
      if (detectedLink && detectedLink !== defaultLink) {
        ctaButton.href = detectedLink;
      }
    }

    initPlaylistModal() {
      const triggers = document.querySelectorAll('.atc-product-pl__playlist-trigger');
      if (triggers.length === 0) return;

      const modal = document.getElementById('playlistModal');
      if (!modal) return;

      const iframeContainer = modal.querySelector('[data-iframe-container]');
      const modalTitle = modal.querySelector('.playlist-modal__title');
      const tabsContainer = modal.querySelector('[data-tabs-container]');
      const tabButtons = modal.querySelectorAll('[data-tab]');
      const closeButtons = modal.querySelectorAll('[data-modal-close]');

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const playlistId = trigger.getAttribute('data-playlist-id');
          const playlistId2 = trigger.getAttribute('data-playlist-id-2');
          const playlistLabel = trigger.getAttribute('data-playlist-label') || 'Premium';
          const playlistLabel2 = trigger.getAttribute('data-playlist-label-2') || 'Gratuit';
          const playlistTitle = trigger.getAttribute('data-playlist-title') || 'Playlist';

          window.currentPlaylistData = {
            id1: playlistId,
            id2: playlistId2,
            label1: playlistLabel,
            label2: playlistLabel2,
            title: playlistTitle
          };

          this.openPlaylistModal(modal, iframeContainer, modalTitle, tabsContainer, tabButtons);
        });
      });

      tabButtons.forEach((tab) => {
        tab.addEventListener('click', () => {
          const tabNum = tab.getAttribute('data-tab');
          this.switchPlaylistTab(tabNum, tabButtons, iframeContainer);
        });
      });

      closeButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.closePlaylistModal(modal, iframeContainer);
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
          this.closePlaylistModal(modal, iframeContainer);
        }
      });
    }

    openPlaylistModal(modal, iframeContainer, modalTitle, tabsContainer, tabButtons) {
      const data = window.currentPlaylistData;
      if (!data) return;

      if (modalTitle) {
        modalTitle.textContent = data.title;
      }

      if (tabsContainer) {
        tabsContainer.style.display = 'flex';
        if (tabButtons[0]) tabButtons[0].textContent = data.label1 || 'Premium';
        if (tabButtons[1]) tabButtons[1].textContent = data.label2 || 'Gratuit';

        if (tabButtons[1]) {
          if (data.id2 && data.id2.trim() !== '') {
            tabButtons[1].disabled = false;
            tabButtons[1].style.opacity = '';
          } else {
            tabButtons[1].disabled = true;
            tabButtons[1].style.opacity = '0.5';
          }
        }
      }

      tabButtons.forEach((btn) => btn.classList.remove('playlist-modal__tab--active'));
      if (tabButtons[0]) {
        tabButtons[0].classList.add('playlist-modal__tab--active');
      }

      this.loadPlaylistIframe(data.id1, iframeContainer);

      modal.setAttribute('aria-hidden', 'false');
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    loadPlaylistIframe(playlistId, container) {
      if (!playlistId || !container) return;
      container.innerHTML = `<iframe src="https://widget.deezer.com/widget/dark/playlist/${playlistId}" width="100%" height="500" frameborder="0" allowtransparency="true" allow="encrypted-media; clipboard-write"></iframe>`;
    }

    switchPlaylistTab(tabNum, tabButtons, iframeContainer) {
      const data = window.currentPlaylistData;
      if (!data) return;

      tabButtons.forEach((btn) => btn.classList.remove('playlist-modal__tab--active'));

      const selectedTab = Array.from(tabButtons).find((btn) => btn.getAttribute('data-tab') === tabNum);
      if (selectedTab) {
        selectedTab.classList.add('playlist-modal__tab--active');
      }

      if (tabNum === '1') {
        this.loadPlaylistIframe(data.id1, iframeContainer);
      } else if (tabNum === '2' && data.id2) {
        this.loadPlaylistIframe(data.id2, iframeContainer);
      }
    }

    closePlaylistModal(modal, iframeContainer) {
      modal.setAttribute('aria-hidden', 'true');
      modal.style.display = 'none';
      document.body.style.overflow = '';
      if (iframeContainer) {
        iframeContainer.innerHTML = '';
      }
    }
  }

  function init() {
    const atcSection = document.querySelector('.atc-product-pl');
    if (!atcSection) {
      new ForYouPlaylistModal();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const forYouSection = event.target.querySelector('[data-section-type="w-for-you"]');
    if (forYouSection) {
      window.ForYouPlaylistModalInitialized = false;
      new ForYouPlaylistModal();
      window.ForYouPlaylistModalInitialized = true;
    }
  });
})();
